<template>
  <input
    ref="input"
    :class="classes"
    :value="value"
    type="text"
    @input="UpdateValue()"
    @blur="blurFunction"
  >
</template>

<script>
  export default {
    props: {
      cssClass: {
        type: String,
        default: "form-control"
      },
      loading: {
        type: Boolean,
        default: false
      },
      blurFunction: {
        type: Function,
        default: Function
      },
      value: {
        type: String,
        default: ""
      }
    },

    computed: {
      classes () {
        let myClass = this.cssClass
        if (this.loading === true) {
          myClass += " element-loading"
        }
        return myClass
      }
    },

    methods: {
      UpdateValue () {
        this.$emit("input", this.$refs.input.value)
      }
    }
  }
</script>
